import React, { FC } from 'react'
import { CrewTraining } from '../core/_requests'

type Props = {
  visible: boolean
  training: CrewTraining | null
  onClose: () => void
}

const TRAINING_TYPE_LABEL: Record<string, string> = {
  PRE_JOINING_VALUE_ADDED: 'Pre Joining Value Added',
  PRE_JOINING_SHIP_SPECIFIC: 'Pre Joining Ship Specific',
  COMPANY_SPECIFIC: 'Company Specific',
  ONBOARD_TRAINING: 'Onboard Training',
  ON_LEAVE_TRAINING: 'On Leave Training',
  OTHER_VALUE_ADDED: 'Other Value Added',
}

const MODE_LABEL: Record<string, string> = {
  REMOTE: 'Remote',
  PHYSICAL: 'Physical',
  VIDEO: 'Video',
}

const WRAP_STYLE: React.CSSProperties = {
  background: 'rgba(0,0,0,0.5)',
  position: 'fixed',
  inset: 0,
  zIndex: 1050,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}

const FIELD_LABEL_STYLE: React.CSSProperties = {
  display: 'block',
  marginBottom: '0.55rem',
  color: '#3F4254',
  fontWeight: 600,
  fontSize: '0.95rem',
}

const SUMMARY_BOX_STYLE: React.CSSProperties = {
  minHeight: 46,
  padding: '0.65rem 0.9rem',
  border: '1px solid #E4E6EF',
  borderRadius: 6,
  background: '#F9F9F9',
  display: 'flex',
  alignItems: 'center',
}

const ViewCrewTrainingModal: FC<Props> = ({ visible, training, onClose }) => {
  if (!visible || !training) return null

  return (
    <div style={WRAP_STYLE}>
      <div className='bg-white rounded shadow-lg' style={{ width: '78vw', maxWidth: 1100, maxHeight: '88vh', overflow: 'auto' }}>
        <div className='d-flex justify-content-between align-items-center border-bottom px-5 py-4'>
          <h5 className='m-0'>View Crew Training</h5>
          <button type='button' className='btn-close' onClick={onClose} />
        </div>

        <div className='p-5'>
          <div className='row g-4'>
            <div className='col-md-4'>
              <label className='form-label fw-semibold' style={FIELD_LABEL_STYLE}>Crew</label>
              <div style={SUMMARY_BOX_STYLE}>{training.crewName || '-'}</div>
            </div>
            <div className='col-md-4'>
              <label className='form-label fw-semibold' style={FIELD_LABEL_STYLE}>Rank</label>
              <div style={SUMMARY_BOX_STYLE}>{training.rankName || '-'}</div>
            </div>
            <div className='col-md-4'>
              <label className='form-label fw-semibold' style={FIELD_LABEL_STYLE}>Mode</label>
              <div style={SUMMARY_BOX_STYLE}>{MODE_LABEL[training.mode] || training.mode || '-'}</div>
            </div>

            <div className='col-md-6'>
              <label className='form-label fw-semibold' style={FIELD_LABEL_STYLE}>Training Type</label>
              <div style={SUMMARY_BOX_STYLE}>{TRAINING_TYPE_LABEL[training.trainingType] || training.trainingType || '-'}</div>
            </div>
            <div className='col-md-6'>
              <label className='form-label fw-semibold' style={FIELD_LABEL_STYLE}>Status</label>
              <div style={SUMMARY_BOX_STYLE}>{training.workflowStatus || '-'}</div>
            </div>

            <div className='col-12'>
              <label className='form-label fw-semibold' style={FIELD_LABEL_STYLE}>Topic</label>
              <div className='border rounded p-3 bg-light' style={{ minHeight: 56, whiteSpace: 'pre-wrap' }}>
                {training.topic?.trim() ? training.topic : 'No topic'}
              </div>
            </div>

            <div className='col-12'>
              <label className='form-label fw-semibold' style={FIELD_LABEL_STYLE}>Remarks</label>
              <div className='border rounded p-3 bg-light' style={{ minHeight: 56, whiteSpace: 'pre-wrap' }}>
                {training.remarks || 'No remarks'}
              </div>
            </div>

            <div className='col-12'>
              <label className='form-label fw-semibold' style={FIELD_LABEL_STYLE}>Office Remarks</label>
              <div className='border rounded p-3 bg-light' style={{ minHeight: 56, whiteSpace: 'pre-wrap' }}>
                {training.officeRemarks || 'No office remarks'}
              </div>
            </div>

            {training.rejectionReason && (
              <div className='col-12'>
                <label className='form-label fw-semibold' style={FIELD_LABEL_STYLE}>Rejection Reason</label>
                <div className='border rounded p-3 bg-light-danger text-danger' style={{ minHeight: 56, whiteSpace: 'pre-wrap' }}>
                  {training.rejectionReason}
                </div>
              </div>
            )}
          </div>
        </div>

        <div className='border-top d-flex justify-content-end px-5 py-4'>
          <button type='button' className='btn btn-light' onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  )
}

export default ViewCrewTrainingModal

